import { useTRPC } from "../../../../trpc/client";
import { useMerchant } from "../../../../hooks/useMerchant";
import { useQuery } from "@tanstack/react-query";

export function useFetchBalance() {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const { data, isLoading } = useQuery(
    trpc.ledgerMovements.getBalance.queryOptions(
      { rentalsMerchantId: merchant?.id ?? "" },
      { enabled: !!merchant?.id }
    )
  );

  return { balance: data ?? null, isLoading };
}
